export const get = (name) => localStorage.getItem(`DI_FLOW.${name}`);
export const set = (name, value) => localStorage.setItem(`DI_FLOW.${name}`, value);
export const remove = (name) => localStorage.removeItem(`DI_FLOW.${name}`);
export const clearLocalStorage = () => localStorage.clear();
